import Vue from 'vue';
import Vuex from 'vuex';
import axios from 'axios';
import { parseLoginToken } from '@/util';

// modules
import agent from './modules/agent';
import settings from './modules/settings';

import eventBus from '@/EventBus';

Vue.use(Vuex);

const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
const LOGOUT = 'LOGOUT';
const LOCAL_STORAGE_TOKEN_KEY = 'token';
const REFRESH_TOKEN_KEY = 'refreshToken';
const IS_AUTHORIZED = 'isAuthorized';

export const store = new Vuex.Store({
  modules: {
    agent,
    settings
  },

  state: {
    menuInfo: {}
  },

  mutations: {
    LOGIN(state) {
      state.pending = true;
    },
    REFRESH(state) {
      state.pending = true;
    },
    LOGIN_SUCCESS(state) {
      state.pending = false;
      localStorage.setItem(IS_AUTHORIZED, 'true');
    },
    REFRESH_SUCCESS(state) {
      state.pending = false;
    },
    LOGOUT() {
      localStorage.setItem(IS_AUTHORIZED, 'false');
    },
    SET_DATA(state, { key, boolean }) {
      state[key] = boolean;
    },
    setMenuInfo(state, menuInfo) {
      state.menuInfo = menuInfo;
    }
  },
  getters: {
    getMenuInfo(state) {
      return state.menuInfo;
    }
  },
  actions: {
    forceLogin({ commit }, forceLoginParameters) {
      return axios({
        method: 'post',
        url: '/api/v2/external/forceLogout',
        data: forceLoginParameters,
        headers: { 'X-Requested-With': 'XMLHttpRequest' }
      });
    },
    setLogin({ commit }, responseData) {
      localStorage.setItem(LOCAL_STORAGE_TOKEN_KEY, responseData.token);
      localStorage.setItem(REFRESH_TOKEN_KEY, responseData.refreshToken);
      commit('setAgentState', parseLoginToken());
      commit(LOGIN_SUCCESS);
    },
    setLogout({ commit }) {
      commit(LOGOUT);
      localStorage.removeItem(LOCAL_STORAGE_TOKEN_KEY);
      localStorage.removeItem(REFRESH_TOKEN_KEY);
      localStorage.removeItem('agent-menus');
      localStorage.removeItem('selectedType');
      localStorage.removeItem('TICKET_LIST_OPTION');
      commit('CLEAR_AGENT');
    },
    logout({ commit, dispatch }, param) {
      return axios({
        method: 'post',
        url: '/auth/logout',
        data: { accountId: parseLoginToken() && parseLoginToken().accountId },
        headers: { 'X-Requested-With': 'XMLHttpRequest' }
      }).then((res) => {
        dispatch('setLogout');
        if (param && !param.busOn) {
          Object.keys(eventBus._events).map((d) => {
            if (d !== 'DialogPopup' && d !== 'ClosePopup') {
              eventBus.$off(d);
            }
          });
        }
        return res;
      });
    },
    forceLogout({ commit, dispatch }) {
      dispatch('setLogout');
      commit('setCheckPaths', []);
      commit('setPathActions', []);
      Object.keys(eventBus._events).map((d) => {
        if (d !== 'DialogPopup' && d !== 'ClosePopup') {
          eventBus.$off(d);
        }
      });
      return true;
    },
    refresh({ commit }) {
      commit('REFRESH');
      return axios({
        method: 'get',
        url: '/auth/refresh',
        headers: { 'X-Requested-With': 'XMLHttpRequest' }
      }).then((res) => {
        const responseData = res.data;
        if (res.status === 200 && responseData.token) {
          const token = responseData.token;
          localStorage.setItem(LOCAL_STORAGE_TOKEN_KEY, token);
          commit('setAgentState', parseLoginToken());
        }
        commit('REFRESH_SUCCESS');
        return res;
      });
    }
  }
});



// WEBPACK FOOTER //
// ./src/store/store.js